<div  class="dialog-container">

  <div class="web-close-icon">
    <button (click)="closedialog()" class="web-close-btn ">
      <span class="material-icons icons-close-mobile" style="position: relative;">{{screenWidth < 480 ?'close' : 'clear'}} </span>
    </button>
  </div>
  <div class="header-content">
    <p class="atvivity-file-name">Activity for <span>{{fileFolderName}}</span></p>
  </div>
  @if (!showTemplte) {
    <div class="file-view-container" >
      @for (activiyItem of activiyLogList; track activiyItem; let i = $index) {
        <div class="file-item-container">
          <div>
            <ngx-avatars
              size="36"
              [src]="activiyItem?.profile_image_url"
              name="{{ activiyItem?.first_name + ' ' + activiyItem?.last_name | titlecase }}"
              [round]="true"
              initialsSize="2"
            ></ngx-avatars>
          </div>
          <div style="margin-left: 12px;">
            <div style="margin-bottom: 6px;font-size: 14px;"  [innerHTML]="activiyItem?.message" ></div>
            <p class="active-tag">
              {{ activiyItem?.when}}
            </p>
          </div>
        </div>
      }
    </div>
  }
  <div >
    @if (showTemplte) {
      <div style="margin: 0 24px;" class="loader-container">
        @for (item of loaderItems; track item) {
          <div>
            <div class="flex loader-body" >
              <div style="border-bottom: 1px solid #e6e6e6;
              border-right: 0px;
              border-left: 0px;
              border-top: 0px;
              padding: 24px 0px;" class="ph-item width-100per loader-body-item">
                <div class="ph-col-12" style="padding: 0px !important">
                  <div class="ph-row">
                    <div class="ph-col-1 ph-avatar flex fl-al-center" style="height: 36px; width: 36px; min-width: auto; margin-left: 12px">
                    </div>
                    <div class="ph-col-8" style="padding: 0px !important;margin-left: 9px;">
                      <div style="margin-bottom: 9px;" class="ph-col-6"></div>
                      <div style="max-width: 148px;" class="ph-col-2"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>